import React, { useEffect, useState } from "react";
import AOS from "aos";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import { render } from "react-dom";
import imag1 from "../image/jin1.jpg";
import img1 from "../image/jin1.jpg";
import img2 from "../image/bts1.jpg";
import img3 from "../image/jimin.jpeg";
import img4 from "../image/worriers.jpg";
import img5 from "../image/img5.jpg";
import img6 from "../image/img6.jpg";
import img7 from "../image/img7.jpg";
import img8 from "../image/img8.jpg";
import img9 from "../image/img9.jpg";
import img10 from "../image/img10.jpg";
import img11 from "../image/img11.jpg";
import img12 from "../image/img12.jpg";
import bts2 from "../image/bts2.jpg";
import bts3 from "../image/bts3.jpg";
import bts4 from "../image/bts4.jpg";
import bts5 from "../image/bts5.jpg";
import bts6 from "../image/bts6.jpg";
import bts7 from "../image/bts7.jpg";
import row22 from "../image/row2,2.jpg";
import row23 from "../image/row2,3.jpg";
import row34 from "../image/row3,4.jpg";
import row41 from "../image/row41.jpg";
import row42 from "../image/row42.jpg";
import row43 from "../image/row43.jpg";
import row44 from "../image/row44.jpg";
import hrow51 from "../image/hrow51.jpg";
import hrow52 from "../image/hrow52.jpg";
import hrow53 from "../image/hrow53.jpeg";
import hrow54 from "../image/hrow54.jpeg";
import logo from "../logo/logo.jpg";
import BackToTop from "./BackToTop";
import { useAuth0 } from "@auth0/auth0-react";
import Login from "./Login";
import Dashboard from "../layout/Dashboard";

const Home = () => {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();

  //login interpretations
  const [isLoggedIn, setLoggedIn] = useState(/* your initial login status */);
  //  const history = useHistory();

  // Function to handle login
  const handleLogin = () => {
    // Your login logic goes here
    // For simplicity, let's just toggle the login status
    setLoggedIn(!isAuthenticated);
    //  history.push('/');
  };

  const handleNavItemClick = (event) => {
    // Check if the user is not logged in, show alert
    if (!isAuthenticated) {
      alert(
        "Please login to access this feature. If not created click login button to singup"
      
      );
      event.preventDefault();
      // history.push('/login');
    } else {
      // Handle navigation logic here
      // For simplicity, let's just navigate to the corresponding page
      // You can use react-router-dom or your preferred routing mechanism
      // For example: history.push('/desired-page');
      // <Redirect to='/login' />
      <p>You have been Enrolled</p>
    }
  };

  const location = useLocation();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);



  
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden">
      <h1>{location.state}</h1>

      {/* <!-- Card Blog --> */}
      <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        {/* <!-- Grid --> */}
        <div
          className="grid grid-cols-2 lg:grid-cols-4 gap-6"
          onClick={handleNavItemClick}
        >
          {/* <!-- Card --> */}
          <NavLink to={""}>
            {" "}
            <a
              className="group rounded-tl-3xl rounded-br-3xl overflow-hidden"
              href="#"
            >
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden -mt-8 lg:-mt-10 border-2  border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full rounded-xl h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out "
                  src={img1}
                  alt="Image Description"
                />
              </div>
              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden -mt-8 lg:-mt-10 border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={img2}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>
          {/* <!-- End Card --> */}

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  lg:-mt-10 border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={bts2}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  lg:-mt-10 border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={bts3}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden   border-2 border-blue-700"
                data-aos="fade-down"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={img5}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-down"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row22}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row23}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={bts7}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-up"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={bts4}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-up"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={bts5}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={bts6}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row34}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row41}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row42}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row43}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={row44}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={hrow51}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-left"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={hrow52}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={hrow53}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>

          <NavLink to={""}>
            {" "}
            <a className="group rounded-xl overflow-hidden" href="#">
              <div
                className="relative pt-[150%] sm:pt-[140%] rounded-xl overflow-hidden  border-2 border-blue-700"
                data-aos="fade-right"
              >
                <img
                  className="w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                  src={hrow54}
                  alt="Image Description"
                />
              </div>

              <div className="">
                <NavLink to="/gallery">
                  {" "}
                  <p
                    className="p-2 lg:p-3 mt-2 inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 group-hover:underline font-medium"
                    onClick={handleNavItemClick}
                  >
                    More Pics
                    <svg
                      className="w-2.5 h-2.5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </a>{" "}
          </NavLink>
        </div>
        {/* <!-- End Grid --> */}
      </div>
      {/* <!-- End Card Blog --> */}
      <div className="counter-wrapper">
            <div className="counter">
                <h1 className="count" data-target="1234">25+</h1>
                <p>New Visiters Every Week</p>
            </div>
            <div className="counter">
                <h1 className="count" data-target="12168">150+</h1>
                <p>Happy customers every year</p>
            </div>
            <div className="counter">
                <h1 className="count" data-target="2172">11+</h1>
                <p>Won Amazing Awards</p>
            </div>
        </div>


        {/* <!-- Features --> */}
<div class="overflow-hidden">
  <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
    {/* <!-- Title --> */}
    <div class="mx-auto max-w-2xl mb-8 lg:mb-14 text-center">
      <h2 class="text-3xl lg:text-4xl text-gray-800 font-bold dark:text-gray-200">
        Solo, Stanning or team fans? We've got you covered.
      </h2>
    </div>
    {/* <!-- End Title --> */}

    <div class="relative xl:w-10/12 xl:mx-auto">
      {/* <!-- Grid --> */}
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        <div>
          {/* <!-- Card --> */}
          <div class="p-4 relative z-10 bg-white border rounded-xl md:p-10 dark:bg-slate-900 dark:border-gray-700">
            <h3 class="text-xl font-bold text-gray-800 dark:text-gray-200">Ordinary</h3>
            <div class="text-sm text-gray-500">Everything a small team needs.</div>

            <div class="mt-5">
              <span class="text-6xl font-bold text-gray-800 dark:text-gray-200">₹299</span>
              <span class="text-lg font-bold text-gray-800 dark:text-gray-200">.00</span>
              <span class="ms-3 text-gray-500">INR</span>
            </div>

            <div class="mt-5 grid sm:grid-cols-2 gap-y-2 py-4 first:pt-0 last:pb-0 sm:gap-x-6 sm:gap-y-0">
              {/* <!-- List --> */}
              <ul class="space-y-2 text-sm sm:text-base">
                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Up to 10 people
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Easy Contact
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Extensibility
                  </span>
                </li>
              </ul>
              {/* <!-- End List --> */}

              {/* <!-- List --> */}
              <ul class="space-y-2 text-sm sm:text-base">
                <li class="flex space-x-3">
                <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Custom reports
                  </span>
                </li>

                <li class="flex space-x-3">
                <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Product support
                  </span>
                </li>

                <li class="flex space-x-3">
                <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Activity reporting
                  </span>
                </li>
              </ul>
              {/* <!-- End List --> */}
            </div>

            <div class="mt-5 grid grid-cols-2 gap-x-4 py-4 first:pt-0 last:pb-0">
              <div>
                <p class="text-sm text-gray-500">Cancel anytime.</p>
                <p class="text-sm text-gray-500">No card required.</p>
              </div>

              <div class="flex justify-end">
               <NavLink to="/orders"> <button type="button" class="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" onClick={handleNavItemClick}>Start free trial</button> </NavLink>
              </div>
            </div>
          </div>
          {/* <!-- End Card --> */}
        </div>

        <div>
          {/* <!-- Card --> */}
          <div class="shadow-xl shadow-gray-200 p-5 relative z-10 bg-white border rounded-xl md:p-10 dark:bg-slate-900 dark:border-gray-700 dark:shadow-gray-900/[.2]">
            <h3 class="text-xl font-bold text-gray-800 dark:text-gray-200">Favourable</h3>
            <div class="text-sm text-gray-500">For growing fans.</div>
            <span class="absolute top-0 end-0 rounded-se-xl rounded-es-xl text-xs font-medium bg-gray-800 text-white py-1.5 px-3 dark:bg-white dark:text-gray-800">Most popular</span>

            <div class="mt-5">
              <span class="text-6xl font-bold text-gray-800 dark:text-gray-200">₹599</span>
              <span class="text-lg font-bold text-gray-800 dark:text-gray-200">.00</span>
              <span class="ms-3 text-gray-500">INR</span>
            </div>

            <div class="mt-5 grid sm:grid-cols-2 gap-y-2 py-4 first:pt-0 last:pb-0 sm:gap-x-6 sm:gap-y-0 lg:-mt-2">
              {/* <!-- List --> */}
              <ul class="space-y-2 text-sm sm:text-base">
                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Up to 27 people
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Easy Contact
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Extensibility
                  </span>
                </li>
              </ul>
              {/* <!-- End List --> */}

              {/* <!-- List --> */}
              <ul class="space-y-2 text-sm sm:text-base">
                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Custom reports
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Product support
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Activity reporting
                  </span>
                </li>

                <li class="flex space-x-3">
                  <span class="mt-0.5 h-5 w-5 flex justify-center items-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-800/30 dark:text-blue-500">
                    <svg class="flex-shrink-0 h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span class="text-gray-800 dark:text-gray-200">
                    Enabled More Features
                  </span>
                </li>
              </ul>
              {/* <!-- End List --> */}
            </div>

            <div class="mt-5 grid grid-cols-2 gap-x-4 py-4 first:pt-0 last:pb-0">
              <div>
                <p class="text-sm text-gray-500">Cancel anytime.</p>
                <p class="text-sm text-gray-500">No card required.</p>
              </div>

              <div class="flex justify-end">
             <NavLink to="/orders">   <button type="button" class="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" onClick={handleNavItemClick}>Start free trial</button> </NavLink>
              </div>
            </div>
          </div>
          {/* <!-- End Card --> */}
        </div>
      </div>
      {/* <!-- End Grid --> */}

      {/* <!-- SVG Element --> */}
      <div class="hidden md:block absolute top-0 end-0 translate-y-16 translate-x-16">
        <svg class="w-16 h-auto text-orange-500" width="121" height="135" viewBox="0 0 121 135" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 16.4754C11.7688 27.4499 21.2452 57.3224 5 89.0164" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
          <path d="M33.6761 112.104C44.6984 98.1239 74.2618 57.6776 83.4821 5" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
          <path d="M50.5525 130C68.2064 127.495 110.731 117.541 116 78.0874" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
        </svg>
      </div>
      {/* <!-- End SVG Element --> */}

      {/* <!-- SVG Element --> */}
      <div class="hidden md:block absolute bottom-0 start-0 translate-y-16 -translate-x-16">
        <svg class="w-56 h-auto text-cyan-500" width="347" height="188" viewBox="0 0 347 188" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 82.4591C54.7956 92.8751 30.9771 162.782 68.2065 181.385C112.642 203.59 127.943 78.57 122.161 25.5053C120.504 2.2376 93.4028 -8.11128 89.7468 25.5053C85.8633 61.2125 130.186 199.678 180.982 146.248L214.898 107.02C224.322 95.4118 242.9 79.2851 258.6 107.02C274.299 134.754 299.315 125.589 309.861 117.539L343 93.4426" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
        </svg>
      </div>
      {/* <!-- End SVG Element --> */}
    </div>

    <div class="mt-7 text-center">
      <p class="text-xs text-gray-400">
      Taxes may apply.
      </p>
    </div>
  </div>
</div>
{/* <!-- End Features --> */}

{/* <!-- Toast --> */}
<div className="flex justify-center p-5">
<div class="bg-white border border-gray-200 rounded-xl shadow-lg dark:bg-gray-800 dark:border-gray-700" role="alert">
  <div class="flex items-center p-4">
    <img src={logo} alt="" height={5} width={25}/>
    <p class="ms-3 text-gray-700 dark:text-gray-400 text-md">
    Visit our <span className="underline text-purple-500 font-bold"><NavLink to="/variety" onClick={handleNavItemClick}>Filmography</NavLink></span> section to view past show information featuring <span className="text-purple-500 font-bold">BTS</span>.
    </p>
  </div>
</div>
</div>
{/* <!-- End Toast --> */}

      <footer>
        <div className="max-w-[85rem] py-10 px-4 sm:px-6 lg:px-8 mx-auto bg-purple-700 ">
          {/* <!-- Grid --> */}
          <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-5 text-center">
            <div>
              {/* <a className="flex-none text-xl font-semibold text-white " href="#" aria-label="Brand">Brand</a> */}
              <div
                className="hover:scale-105 transition-transform duration-500 ease-in-out rounded-tl-3xl rounded-br-3xl w-full object-cover text-center border-2 p-1  border-purple-400 "
                data-aos="zoom-in"
              >
                <img
                  className="rounded-tl-xl rounded-br-xl border-2  border-blue-400 hover:border-purple-400  sm:w-48 sm:h-48 lg:w-60 lg:h-60 mx-auto tranblue-y-2 hover:scale-105 transition-transform duration-500 ease-in-out w-full object-cover"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMmiau04xpdhBmGom7KwL474Gw9b1-F5-3pQ&usqp=CAU"
                  alt="Image Description"
                />
              </div>
            </div>
            {/* <!-- End Col --> */}

            <ul className="text-center" data-aos="zoom-out-down">
              <li className="inline-block relative pr-8 last:pr-0 last-of-type:before:hidden before:absolute before:top-1/2 before:right-3 before:-translate-y-1/2 before:content-['/'] before:text-gray-300 dark:before:text-gray-600">
                <NavLink to="/aboutus">
                  {" "}
                  <a
                    className="inline-flex gap-x-2 text-sm text-white hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
                    href="#" onClick={handleNavItemClick}
                  >
                    About Us
                  </a>
                </NavLink>
              </li>
              <li className="inline-block relative pr-8 last:pr-0 last-of-type:before:hidden before:absolute before:top-1/2 before:right-3 before:-translate-y-1/2 before:content-['/'] before:text-gray-300 dark:before:text-gray-600">
                <NavLink to="/gallery">
                  {" "}
                  <a
                    className="inline-flex gap-x-2 text-sm text-white hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
                    href="#" onClick={handleNavItemClick}
                  >
                    Gallery
                  </a>{" "}
                </NavLink>
              </li>
            </ul>
            {/* <!-- End Col --> */}
            <div className="-ml-3 lg:ml-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15551.135153652767!2d77.5545749!3d12.9856763!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3df485b9a8bf%3A0xf28a75e7f8eb2569!2sOZEO%20IT%20BUSINESS%20SERVICES%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1701418727636!5m2!1sen!2sin"
                width="400"
                height="300"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
              ></iframe>
            </div>
          </div>
          {/* <!-- End Grid --> */}
        </div>
      </footer>
      <BackToTop />
      {!isAuthenticated ? <code></code> : <code></code>}
    </div>
  );
};

export default Home;
